let scrollY = 0;

const onRevealScreenSize = (el, breakPoint = 1200) => {
  const windowWidth = window.innerWidth;
  const isMobile = windowWidth < breakPoint;
  const isDesktop = windowWidth >= breakPoint;

  if (el.classList.contains('reveal-mobile-only')) {
    return isMobile;
  }

  if (el.classList.contains('reveal-desktop-only')) {
    return isDesktop;
  }

  return true;
};

function applyRevealStyles() {
  const reveals = document.querySelectorAll('.reveal-block');

  reveals.forEach((reveal) => {
    const link = reveal.classList.contains('reveal-link');

    const breakClass = Array.from(reveal.classList).find((className) =>
      className.startsWith('reveal-break-')
    );
    const breakPoint = breakClass
      ? parseInt(breakClass.replace('reveal-break-', ''), 10)
      : 1200;

    const idClass = Array.from(reveal.classList).find((className) =>
      className.startsWith('reveal-id-')
    );
    const id = idClass ? idClass.replace('reveal-id-', '') : null;

    const contentElement = document.querySelector(
      '.reveal-content.reveal-id-' + id
    );

    if (link) {
      reveal.style.position = 'relative';

      let shouldShowIcon = true;

      if (reveal.classList.contains('reveal-mobile-only')) {
        reveal.style.cursor =
          window.innerWidth >= breakPoint ? 'initial' : 'pointer';
        shouldShowIcon = window.innerWidth < breakPoint;
      } else if (reveal.classList.contains('reveal-desktop-only')) {
        reveal.style.cursor =
          window.innerWidth < breakPoint ? 'initial' : 'pointer';
        shouldShowIcon = window.innerWidth >= breakPoint;
      } else {
        reveal.style.cursor = 'pointer';
        shouldShowIcon = true;
      }

      const iconOption = reveal.getAttribute('data-reveal-icon');
      let iconClosed = reveal.getAttribute('data-reveal-icon-closed');
      let iconOpened = reveal.getAttribute('data-reveal-icon-opened');

      reveal.querySelector('.reveal-icon-closed')?.remove();
      reveal.querySelector('.reveal-icon-opened')?.remove();

      let hasIcons = false;

      if (iconOption !== 'none' && iconClosed && iconOpened && shouldShowIcon) {
        const closedIconElement = document.createElement('span');
        closedIconElement.classList.add('reveal-icon-closed');
        closedIconElement.style.position = 'absolute';
        closedIconElement.style.right = '-.25rem';
        closedIconElement.style.top = '60%';
        closedIconElement.style.transform = 'translateY(-50%)';
        const closedImg = document.createElement('img');
        closedImg.src = iconClosed;
        closedIconElement.appendChild(closedImg);
        reveal.prepend(closedIconElement);

        const openedIconElement = document.createElement('span');
        openedIconElement.classList.add('reveal-icon-opened');
        openedIconElement.style.position = 'absolute';
        openedIconElement.style.right = '-.25rem';
        openedIconElement.style.top = '60%';
        openedIconElement.style.transform = 'translateY(-50%)';
        openedIconElement.style.display = 'none';
        const openedImg = document.createElement('img');
        openedImg.src = iconOpened;
        openedIconElement.appendChild(openedImg);
        reveal.prepend(openedIconElement);

        hasIcons = true;
      }

      reveal.style.marginRight = hasIcons ? '1.5rem' : '';
    }

    if (contentElement) {
      contentElement.style.overflow = 'hidden';
      contentElement.style.transition = 'all 0.3s ease-out';

      if (reveal.classList.contains('reveal-mobile-only')) {
        contentElement.style.maxHeight =
          window.innerWidth >= breakPoint ? 'initial' : '0';
      } else if (reveal.classList.contains('reveal-desktop-only')) {
        contentElement.style.maxHeight =
          window.innerWidth < breakPoint ? 'initial' : '0';
      } else {
        contentElement.style.maxHeight = '0';
      }

      if (contentElement.classList.contains('reveal-expanded')) {
        contentElement.style.maxHeight = 'initial';
      }
    }
  });
}

function closeOtherReveals(currentReveal, groupClass) {
  const revealsInGroup = document.querySelectorAll(
    `.reveal-link.${groupClass}`
  );
  revealsInGroup.forEach((reveal) => {
    const idClass = Array.from(reveal.classList).find((className) =>
      className.startsWith('reveal-id-')
    );
    const id = idClass ? idClass.replace('reveal-id-', '') : null;
    const contentElement = document.querySelector(
      '.reveal-content.reveal-id-' + id
    );

    if (contentElement && contentElement !== currentReveal) {
      contentElement.classList.remove('reveal-expanded');
      contentElement.style.maxHeight = '0';
      reveal.setAttribute('aria-expanded', 'false');

      const closedIcon = reveal.querySelector('.reveal-icon-closed');
      const openedIcon = reveal.querySelector('.reveal-icon-opened');

      if (closedIcon) closedIcon.style.display = 'block';
      if (openedIcon) openedIcon.style.display = 'none';
    }
  });
}

function initReveal() {
  const reveals = document.querySelectorAll('.reveal-block');

  reveals.forEach((reveal) => {
    const link = reveal.classList.contains('reveal-link');

    const breakClass = Array.from(reveal.classList).find((className) =>
      className.startsWith('reveal-break-')
    );
    const breakPoint = breakClass
      ? parseInt(breakClass.replace('reveal-break-', ''), 10)
      : 1200;

    const idClass = Array.from(reveal.classList).find((className) =>
      className.startsWith('reveal-id-')
    );
    const id = idClass ? idClass.replace('reveal-id-', '') : null;

    const contentElement = document.querySelector(
      '.reveal-content.reveal-id-' + id
    );

    if (contentElement) {
      if (breakClass) {
        contentElement.classList.add(breakClass);
      }

      const groupClass = Array.from(reveal.classList).find((className) =>
        className.startsWith('reveal-group-')
      );
      if (groupClass) {
        contentElement.classList.add(groupClass);
      }

      if (reveal.classList.contains('reveal-mobile-only')) {
        contentElement.classList.add('reveal-mobile-only');
      }

      if (reveal.classList.contains('reveal-desktop-only')) {
        contentElement.classList.add('reveal-desktop-only');
      }

      reveal.setAttribute('role', 'button');
      reveal.setAttribute('aria-controls', id);
      reveal.setAttribute('aria-expanded', 'false');
      reveal.setAttribute('tabindex', '0');
      contentElement.setAttribute('role', 'region');
      contentElement.setAttribute('aria-labelledby', id);
    }

    reveal.addEventListener('click', function (event) {
      event.preventDefault();

      if (link && onRevealScreenSize(reveal, breakPoint)) {
        const groupClass = Array.from(reveal.classList).find((className) =>
          className.startsWith('reveal-group-')
        );

        const isScreenFreeze = reveal.classList.contains(
          'reveal-freeze-screen'
        );

        const toggleReveal = () => {
          contentElement.classList.toggle('reveal-expanded');
          const isExpanded =
            contentElement.classList.contains('reveal-expanded');
          contentElement.style.maxHeight = isExpanded ? 'initial' : '0';
          reveal.setAttribute('aria-expanded', isExpanded);

          if (isExpanded) {
            contentElement.removeAttribute('inert');
          } else {
            contentElement.setAttribute('inert', '');
          }

          const closedIcon = reveal.querySelector('.reveal-icon-closed');
          const openedIcon = reveal.querySelector('.reveal-icon-opened');

          if (closedIcon && openedIcon) {
            closedIcon.style.display = isExpanded ? 'none' : 'block';
            openedIcon.style.display = isExpanded ? 'block' : 'none';
          }

          if (isScreenFreeze) {
            if (isExpanded) {
              scrollY = window.scrollY;
              document.body.classList.add('reveal-frozen');
              document.body.style.top = `-${scrollY}px`;
              document.body.style.maxHeight = '100vh';
              document.body.style.overflowY = 'hidden';
            } else {
              document.body.classList.remove('reveal-frozen');
              document.body.style.top = '';
              document.body.style.maxHeight = '';
              document.body.style.overflowY = '';
              window.scrollTo(0, scrollY);
            }
          }
        };

        if (groupClass) {
          const isCloseable = reveal.classList.contains('reveal-closable');
          const expandedReveals = document.querySelectorAll(
            `.reveal-content.reveal-expanded.${groupClass}`
          );

          if (
            expandedReveals.length > 1 ||
            !contentElement.classList.contains('reveal-expanded') ||
            isCloseable
          ) {
            closeOtherReveals(contentElement, groupClass);
            toggleReveal();
          }
        } else {
          toggleReveal();
        }
      }
    });

    reveal.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        reveal.click();
      }
    });
  });

  applyRevealStyles();
}

document.addEventListener('DOMContentLoaded', function () {
  initReveal();
});

window.addEventListener('resize', function () {
  applyRevealStyles();
});
